export default [
 {
  media: { icon: ['far', 'lightbulb'], color: 'warning', className: 'fs-5' },
  title: 'Innovacion',
  description:
   'Ofrecer soluciones veterinarias reales, prácticas y comprensivas para las diversas necesidades de salud de tus mascotas.'
 },
 {
  media: { icon: 'users', color: 'success', className: 'fs-6' },
  title: 'Trabajo en equipo',
  description:
   'Fomentar la colaboración entre nuestros veterinarios, técnicos y personal de apoyo para brindar un cuidado coordinado y completo a cada paciente.'
 },
 {
  media: {
   icon: 'bolt',
   color: 'primary',
   className: 'fs-5'
  },
  title: 'Eficiencia',
  description:
   'Brindar una gestión optimizada de los procesos de atención y seguimiento de la salud de tus mascotas a través de la tecnología y la organización.'
 }
];
